const Image = ({ src, alt, height, width, className, loading, fetchPriority }) => {
  return (
    <img
      loading={loading}
      fetchpriority={fetchPriority}
      src={src}
      alt={alt}
      className={className}
      height={height}
      width={width}
    />
  );
};

export default Image;
